_ = require("lodash")
$ = require("jquery")

FriendCtrl = ($scope, $filter, $window, $timeout, flash, FriendService) ->
  createQueryOptions = ->
    page: $scope.pageOptions.currentPage
    page_size: $scope.pageOptions.pageSize
    sort: do ->
      return unless $scope.sort.column
      sortOrder = if $scope.sort.descending then "desc" else "asc"
      "#{$scope.sort.column}:#{sortOrder}"

  getEditingFriend = ->
    _.find $scope.friends, (f) ->
      f.isEditMode

  hasInvalidEditingFriend = ->
    friend = getEditingFriend()
    return false unless friend
    return friend.form.$invalid

  #variables
  $scope.pageOptions =
    totalItems: 0
    currentPage: 1
    pageSize: 15

  $scope.friends = []
  $scope.isLoading = false
  $scope.sort =
    column: undefined
    descending: false
  $scope.newFriend =
    name: undefined
    email: undefined
    player_hdcp: undefined

  #listing
  $scope.loadData = ->
    $scope.isLoading = true
    FriendService.getFriends(createQueryOptions()).then (result) ->
      $scope.friends = result.players
      $scope.pageOptions.totalItems = result.total
      # keep editing state for current selected row
      if $scope.editingFriend
        _.forEach $scope.friends, (friend) ->
          if friend.id == $scope.editingFriend.id
            friend.isEditMode = true
    .finally ->
      $scope.isUpdatedHdcpList = false
      $scope.isLoading = false

  $scope.changeSort = (column) ->
    if ($scope.sort.column is column)
      $scope.sort.descending = !$scope.sort.descending
    else
      $scope.sort.column = column
      $scope.sort.column.descending = false

    $scope.loadData()

  $scope.sortClass = (column) ->
    return "" if $scope.sort.column isnt column
    return "desc" if $scope.sort.descending
    "asc"

  #adding
  $scope.addFriend = ->
    $scope.isLoading = true
    FriendService.addFriend($scope.newFriend).then (resp) ->
      flash.success $filter('translate')('API_SUCCESS')
      $scope.friends.unshift _.cloneDeep($scope.newFriend)
      $scope.newFriend.highlight = true
      $scope.clearFriend()
      $scope.loadData()
    .catch (resp) ->
      if resp.data?.code is 'error.name_already_taken'
        flash.error $filter('translate')('NAME_DUPLICATED')
      else
        flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isLoading = false

  $scope.clearFriend = ->
    $scope.newFriend.name = undefined
    $scope.newFriend.email = undefined
    $scope.newFriend.player_hdcp = undefined
    $scope.newFriend.form.$setPristine()
    $scope.newFriend.form.submitted = false

  #editing
  $scope.clearAllEditMode = ->
    editingFriend = getEditingFriend()

    return unless editingFriend
    if not editingFriend.isDataChanged()
      editingFriend.isEditMode = false
      return

    if editingFriend.form.$invalid
      editingFriend.form.submitted = true #show error
      editingFriend.form.$setDirty()
    else
      $scope.updateFriend(editingFriend)

  $scope.toggleEdit = (event, friend) ->
    if not $scope.isUpdatedHdcpList
      $scope.isUpdatedHdcpList = true
      $('.dropdown-toggle').dropdown()
    if friend.isEditMode
      $scope.$broadcast('dropdownListClose')
    #prevent action from parent node
    event.stopImmediatePropagation()
    return if friend.isEditMode
    return if hasInvalidEditingFriend()
    $scope.clearAllEditMode()
    friend.isEditMode = true
    $scope.editingFriend = friend
    return

  $scope.updateFriend = (friend) ->
    return unless friend.isDataChanged()
    $scope.isLoading = true
    FriendService.updateFriend(friend).then (resp) ->
      flash.success $filter('translate')('API_SUCCESS')
      friend.isEditMode = false
      friend.highlight = true
      $scope.loadData()
    .catch (resp) ->
      if resp.data?.code is 'error.name_already_taken'
        flash.error $filter('translate')('NAME_DUPLICATED')
      else
        flash.error $filter('translate')('API_ERROR')
    .finally ->
      $scope.isLoading = false

  $scope.cancelEditFriend = (friend) ->
    friend.restore()
    friend.isEditMode = false
    friend.form.$setPristine()
    friend.form.submitted = false

  #deleting
  $scope.removeFriend = (event, friend) ->
    #Do not turn on edit mode when clicking remove button
    event.stopImmediatePropagation()
    if $window.confirm $filter('translate')('CONFIRMATION_MSG')
      $scope.isLoading = true
      FriendService.removeFriend(friend).then (resp) ->
        flash.success $filter('translate')('API_SUCCESS')
        $scope.loadData()
      .finally ->
        $scope.isLoading = false

  $scope.handleKeyDown = ($event, friend) ->
    if $event.which is 13
      $timeout ->
        $($event.target).closest('form').submit()
      return false
    else if $event.which is 27 and friend
      $scope.cancelEditFriend(friend)
  #initializing
  $scope.loadData()


FriendCtrl.$inject = [
  '$scope'
  '$filter'
  '$window'
  '$timeout'
  'flash'
  'FriendService'
]

module.exports = FriendCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/friend/friend-controller.coffee